import { render, staticRenderFns } from "./SignInMethod.vue?vue&type=template&id=1ad1276c&scoped=true&"
import script from "./SignInMethod.vue?vue&type=script&lang=js&"
export * from "./SignInMethod.vue?vue&type=script&lang=js&"
import style0 from "./SignInMethod.vue?vue&type=style&index=0&id=1ad1276c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad1276c",
  null
  
)

export default component.exports